module.exports = __webpack_public_path__ + "static/media/legal-protection-icon.22b629e5.svg";